export const voiceAgent = {
  header: {
    title: "Agente de Voz com IA",
    subBefore: "Atende suas chamadas telefônicas com IA em tempo real. Aplica-se a",
    subEmphasis: "toda a sua conta",
    active: "Ativo",
    inactive: "Inativo",
  },
  loading: "Carregando configuração…",
  errors: {
    load: "Não foi possível carregar a configuração.",
    save: "Não foi possível salvar. Tente novamente.",
  },
  phone: {
    title: "Número de telefone",
    desc: "O número para o qual seus hóspedes ligam. Um número dedicado é criado para a sua conta.",
    checking: "Verificando seu número…",
    pendingTitle: "Telefonia pendente de ativação",
    pendingText: "A criação de número ainda não está habilitada na sua conta. Entre em contato e nós ativaremos.",
    activeCountry: "Ativo · país {country}",
    provisioning: "Provisionando… (pode levar alguns minutos)",
    release: "Liberar",
    numberCountry: "País do número",
    searching: "Buscando…",
    seeAvailable: "Ver disponíveis",
    perMonth: "{cost}/mês",
    getThis: "Obter este número",
    getOne: "Obter um número",
    confirmRelease: "Tem certeza de que deseja liberar o número? Ele deixará de receber chamadas.",
    errNoneInCountry: "Nenhum número disponível neste país no momento.",
    errTelnyxInactive: "A telefonia ainda não está ativa na sua conta.",
    errSearchFailed: "Não foi possível buscar números.",
    errTelnyxInactiveContact: "A telefonia ainda não está ativa na sua conta. Entre em contato e nós habilitaremos.",
    errNoNumbersNow: "Nenhum número disponível no momento.",
    errProvisionFailed: "Não foi possível obter o número.",
    errReleaseFailed: "Não foi possível liberar o número.",
  },
  voiceLang: {
    title: "Voz e idioma",
    assistantVoice: "Voz do assistente",
    recommended: "(recomendada)",
    listenVoiceTitle: "Ouvir a voz {voice}",
    loading: "Carregando…",
    stop: "Parar",
    listen: "Ouvir",
    mainLanguage: "Idioma principal",
    extraLanguages: "Idiomas adicionais que ele pode falar",
    useIdentityTitle: "Usar a identidade do agente de chat",
    useIdentityDesc: "Reutiliza o nome, a personalidade e o tom que você já definiu em Configurações Gerais.",
    voiceAssistantName: "Nome do assistente de voz",
    namePlaceholder: "ex.: recepção do Málaga Centro Suites",
    greeting: "Saudação ao atender",
    optional: "(opcional)",
    greetingPlaceholder: "Se deixado em branco, o assistente saúda automaticamente com sua identidade.",
    errPlayback: "Não foi possível reproduzir a amostra.",
    errGenerate: "Não foi possível gerar a amostra de voz. Tente novamente.",
  },
  languages: {
    es: "Espanhol",
    en: "Inglês",
    fr: "Francês",
    pt: "Português",
    it: "Italiano",
    de: "Alemão",
    ar: "Árabe",
  },
  countries: {
    ES: "Espanha",
    US: "Estados Unidos",
    GB: "Reino Unido",
    FR: "França",
    IT: "Itália",
    DE: "Alemanha",
    PT: "Portugal",
    CO: "Colômbia",
    MX: "México",
  },
  days: {
    mon: "Seg",
    tue: "Ter",
    wed: "Qua",
    thu: "Qui",
    fri: "Sex",
    sat: "Sáb",
    sun: "Dom",
  },
  listings: {
    title: "Acomodações para as quais ele atende",
    desc: "Escolha para quais acomodações o agente de voz atende as chamadas.",
    all: "Todas as acomodações",
    some: "Apenas algumas",
    scopeNoteBefore: "Ele atende",
    scopeNoteStrong: "todas",
    scopeNoteAfter: "as acomodações da conta, incluindo qualquer uma que você adicione no futuro.",
    searchPlaceholder: "Buscar acomodação…",
    selectAll: "Selecionar todas",
    clearAll: "Limpar tudo",
    loadingListings: "Carregando acomodações…",
    noListings: "Esta conta não tem acomodações.",
    noMatches: "Nenhum resultado.",
    noneWarn: "Se você não selecionar nenhuma, o agente atenderá por todas.",
    allDesc: "Incluindo os que adicionares no futuro.",
    someDesc: "Apenas os que marcares aqui em baixo.",
    selectedShort: "{n} de {total}",
  },
  capabilities: {
    title: "O que ele pode fazer",
    knowledgeTitle: "De onde tira a informação",
    knowledgeDesc: "Escolhe o que o assistente consulta quando lhe perguntam pelo alojamento.",
    messagesTitle: "Anotar recados",
    messagesDesc: "Se não souber algo, ele anota o recado do hóspede e avisa você.",
    linksTitle: "Enviar links após a chamada",
    linksDesc: "Depois de desligar, ele envia o link útil (check-in ou reserva) pelo WhatsApp quando for relevante.",
    photosTitle: "Enviar fotos dos equipamentos e comodidades",
    photosDesc: "Se quem liga perguntar por uma comodidade que tenha fotos, o agente as envia por WhatsApp para o número de onde está ligando.",
  },
  doc: {
    title: "Documento com informação",
    desc: "Carregue um PDF ou um Word e o agente poderá responder com o que estiver lá dentro.",
    dropTitle: "Carregar um documento",
    dropHint: "PDF ou Word (.docx), até 15 MB",
    uploading: "A carregar o documento…",
    replace: "Substituir",
    remove: "Remover",
    chars: "{n} caracteres lidos",
    noText: "Este documento está digitalizado: são imagens e o texto não pode ser lido. Carregue um com texto a sério.",
    errType: "O ficheiro tem de ser PDF ou Word (.docx).",
    errSize: "O ficheiro não pode passar dos 15 MB.",
    errUpload: "Não foi possível carregar o documento. Tente outra vez.",
    errRemove: "Não foi possível remover o documento. Tente outra vez.",
    fuenteBase: "A base de conhecimento",
    fuenteBaseDesc: "A ficha dos teus alojamentos: check-in, serviços, regras e FAQ.",
    fuenteDoc: "Um documento teu",
    fuenteDocDesc: "Apenas o PDF ou Word que carregares aqui em baixo, com as suas instruções.",
    fuenteAmbas: "As duas",
    fuenteAmbasDesc: "Primeiro o documento e, se a resposta não estiver lá, a ficha do alojamento.",
    verTexto: "Ver o que o assistente lê",
    abrirOriginal: "Abrir o documento",
    previewTitle: "O que o assistente lê do teu documento",
    previewSub: "É o texto retirado do ficheiro. Se aqui faltar algo, o assistente também não o sabe.",
    previewVacio: "Não foi possível retirar texto deste ficheiro.",
    cerrar: "Fechar",
    noUsado: "Está carregado, mas o assistente não o está a usar: escolheste responder só com a base de conhecimento.",
    faltaDoc: "Carrega um documento para o poderes escolher como fonte.",
  },
  hours: {
    title: "Horário de atendimento",
    specific: "Horários específicos",
    closed: "Fechado",
    afterHours: "Fora do horário",
    afterVoicemail: "Gravar mensagem de voz",
    afterMessage: "Reproduzir um aviso e desligar",
    afterMessagePlaceholder: "Mensagem reproduzida fora do horário.",
  },
  recording: {
    title: "Gravação e conformidade",
    recordTitle: "Gravar chamadas",
    recordDesc: "Salva o áudio das chamadas para você poder revisá-lo.",
    noticeTitle: "Anunciar gravação",
    noticeDesc: "O assistente informa no início que a chamada pode ser gravada (recomendado pelo GDPR).",
    transcribeTitle: "Transcrever chamadas",
    transcribeDesc: "Gera um texto de cada conversa.",
    transcribeNeedsRecord: "A transcrição é tirada do áudio: com «Gravar as chamadas» desligado, não se gera nenhuma.",
  },
  advanced: {
    title: "Avançado",
    maxDuration: "Duração máxima da chamada",
    minutesOption: "{n} minutos",
    aiEngine: "Motor de IA",
  },
  save: {
    saved: "Salvo ✓",
    save: "Salvar alterações",
    dirty: "Você tem alterações não salvas",
    clean: "Tudo salvo",
  },
  credits: {
    title: "Minutos de chamadas",
    desc: "Minutos incluídos todo mês conforme seus alojamentos. Quando acabarem, recarregue quando quiser.",
    loading: "Carregando saldo…",
    minutesLeft: "min disponíveis",
    recharge: "Recarregar",
    includedThisMonth: "{used} de {total} min incluídos usados neste mês",
    purchased: "{min} min comprados",
    empty: "Seus minutos acabaram. Recarregue para continuar recebendo chamadas.",
    error: "Não foi possível carregar o saldo.",
    modal: {
      title: "Recarregar minutos",
      sub: "Escolha um pacote. O pagamento é único e os minutos entram no seu saldo na hora.",
      pay: "Pagar com cartão",
      secure: "Pagamento seguro com Stripe.",
      close: "Fechar",
      error: "Não foi possível iniciar o pagamento. Tente novamente.",
    },
  },
};
